import { authorizationPolicy } from './policies/AuthorizationPolicy';
import { BackInStockConfiguration } from '../helpers/BackInStockConfiguration';
import { tenantPolicy } from './policies/TenantPolicy';
import { Api } from '@ori/global-api-client';
import { deserializationPolicy, exponentialRetryPolicy, redirectPolicy, systemErrorRetryPolicy, } from '@azure/ms-rest-js';
class ClientProvider {
    create() {
        const options = {
            baseUri: BackInStockConfiguration.get().apiUrl,
            requestPolicyFactories: [
                authorizationPolicy(),
                tenantPolicy(),
                deserializationPolicy(),
                redirectPolicy(),
                exponentialRetryPolicy(),
                systemErrorRetryPolicy(),
            ],
        };
        return new Api(options);
    }
    get client() {
        if (!this.clientInternal) {
            this.clientInternal = this.create();
        }
        return this.clientInternal;
    }
}
const clientProvider = new ClientProvider();
export const getApiClient = () => clientProvider.client;
